import { ErrorCodeType } from "application/models/IError";
import { GetError } from "utils/GetError";
import { Order } from "../../../domains/order/agreggates/order/Order";
import { FinancialTransactionModel } from "../../../domains/order/agreggates/payment/FinancialTransactionModel";
import { TransactionType } from "../../../domains/order/agreggates/payment/transactionType";
import { IOrderRepository } from "../../../domains/order/interfaces/repositories/IOrderRepository";
import { IHttpRepository } from "../../interfaces/IHttpRepository";
import { IPasswordPainel } from "../../interfaces/IPasswordPainel";
import {
  DadosPedidosPOS,
  PedidoPos,
  responseSyncPedidoPos,
  SyncStatus,
} from "../../interfaces/PedidoMeep";
import { LocalStorageCashlessOfflineRepository } from "../localStorage/LocalStorageCashlessOfflineRepository";
import { LocalStorageSyncPendingsRepository } from "../localStorage/LocalStorageSyncPendingsRepository";
import { getOrderRepository } from "../localStorage/getOrderRepository";
import { HttpRepository } from "./_HttpRepository";
import { orderToPedidoPOS, pedidoPosToLog } from "./_Parses";
import { CashlessRepository } from "./CashlessRepository";
import { ISyncOrderResult } from "modules/order/application/useCases/SyncOrderUseCase";
import { IRechargeAccountRequest } from "domains/cashless/aggregates/IRechargeAccount";
import { Kiosk } from "domains/kiosk/aggregates/Kiosk";

const httpRepository: IHttpRepository = HttpRepository();
const cashlessRepository = CashlessRepository();
const orderRepository = getOrderRepository();
const cashlessOfflineRepository = LocalStorageCashlessOfflineRepository();
const syncPendingOrdersRepository = LocalStorageSyncPendingsRepository();

export const MeepOrderRepository = (
  addLog?: (log: string, data: any) => void
): IOrderRepository => {
  //Salvar pedidos na fila de sincronização
  const sendOrderAsync = async (
    order: Order,
    tipoPagamento: TransactionType,
    transacaoAdquirente?: FinancialTransactionModel
  ) => {
    const pedidoPos = orderToPedidoPOS(
      order,
      tipoPagamento,
      transacaoAdquirente
    );
    await syncPendingOrdersRepository.saveStorageOrder([pedidoPos]);
    return pedidoPos;
  };

  const sendOrderOfflineRechargeAsync = async (
    order: Order,
    tipoPagamento: TransactionType,
    transacaoAdquirente?: FinancialTransactionModel,
  ) => {
    const pedidoPos = orderToPedidoPOS(
      order,
      tipoPagamento,
      transacaoAdquirente
    );
    await cashlessOfflineRepository.savePendentConfirmationRecordOfflineOrders(
      [pedidoPos]
    );
    return pedidoPos;
  };

  const SincronizarPedidoPOSAsync = async (
    dadosPedidosPOS: DadosPedidosPOS
  ) => {
    addLog &&
      addLog(
        "Request SincronizarPedidoPOSAsync",
        pedidoPosToLog(
          JSON.parse(dadosPedidosPOS.sincronizarPedidoPOSInsertModel) ?? []
        )
      );
    let response = await httpRepository.postAsync<
      DadosPedidosPOS,
      responseSyncPedidoPos[]
    >("/Pagamento/SincronizarPedidoPOS", dadosPedidosPOS);
    // >("https://5a78a3c20b7b.ngrok-free.app/Promptus.Meep.Server/api/Pagamento/SincronizarPedidoPOS", dadosPedidosPOS);
    await Promise.all(
      response.map((it, key) =>
        setTimeout(() => {
          orderRepository.add(
            { id: it.pedidoPOSId, isSynchronized: true } as Order,
            "Sincronizado com sucesso!"
          );
        }, key * 500)
      )
    );
    return response;
  };

  const getPasswordPainel = async (
    sessaoId: string,
    localId: string
  ): Promise<IPasswordPainel> => {
    return await httpRepository.getAsync<IPasswordPainel>(
      `PasswordPanel/NextOrderPasssoword/LocalClient/${localId}/Cashier/${sessaoId}`
    );
  };

  const syncOrdersAsync = async (localClienteId: string, equipamentId: string) => {
    const storagePedidosPOS =
      await syncPendingOrdersRepository.getStoragePendentOrder();
    let responseSync: responseSyncPedidoPos[] = [];

    if (storagePedidosPOS && storagePedidosPOS?.length > 0) {
      // Caso pagamento seja pix, será sincronizado como debito
      const pedidoPosParaSincronizar = storagePedidosPOS.map((it) => ({
        ...it,
        tipoPagamento:
          it.tipoPagamento === TransactionType.pix
            ? TransactionType.debit
            : it.tipoPagamento,
      }));

      const dadosPedidoPOS: DadosPedidosPOS = {
        localClienteId: localClienteId,
        tipoDispositivo: 2,
        superAppEventId: pedidoPosParaSincronizar[0]?.superAppEventId,
        sincronizarPedidoPOSInsertModel: JSON.stringify(
          pedidoPosParaSincronizar ?? "[]"
        ),
      };
      addLog && addLog("Request syncOrdersAsync", pedidoPosToLog(pedidoPosParaSincronizar));
      const result = await SincronizarPedidoPOSAsync(dadosPedidoPOS);
      if (result) {
        responseSync = [...responseSync, ...result];
        await syncPendingOrdersRepository.removeSendedOrderFromStorageQueueAsync(
          result
        );
      }
    }


    // Sincronização de pedidos de recarga offline
    let StorageOfflineOrdersToConfirmSync =
      await cashlessOfflineRepository.getNotSincronizedOfflineRecharges();

    console.log("storagePedidosPOSConfirmationRecord", StorageOfflineOrdersToConfirmSync);
    if (
      StorageOfflineOrdersToConfirmSync &&
      StorageOfflineOrdersToConfirmSync?.length > 0
    ) {
      console.log("StorageOfflineOrdersToConfirmSync", StorageOfflineOrdersToConfirmSync);
      // Caso pagamento seja pix, será sincronizado como debito
      StorageOfflineOrdersToConfirmSync =
        StorageOfflineOrdersToConfirmSync.map((it) => ({
          ...it,
          tipoPagamento:
            it.tipoPagamento === TransactionType.pix
              ? TransactionType.debit
              : it.tipoPagamento,
        }));

      const pedidoPosParaSyncronizar = StorageOfflineOrdersToConfirmSync.filter(
        (it) => !it.sincronized
      );

      if (pedidoPosParaSyncronizar.length) {
        pedidoPosParaSyncronizar.forEach(async (it) => {
          console.log("it to sync", it);
          const result = await syncPreCashlessOffline(it, localClienteId, equipamentId, it.tipoPagamento ?? TransactionType.misto);
          if (result) {
            console.log("result", result);
            await cashlessOfflineRepository.markAsSincronized(it.pedidoPOSId ?? "");
            console.log("marked as synchronized", it.pedidoPOSId);
          }
        });
      }
    }

    let StorageOfflineOrdersToRecorded = await cashlessOfflineRepository.getSincronizedOfflineRechargesAndNotRecorded();
    const ordersIdToConfirmRecord = StorageOfflineOrdersToRecorded
      .map((it) => it.pedidoPOSId ?? "")
      .filter(
        (id) => !storagePedidosPOS?.map((i) => i.pedidoPOSId).includes(id)
      );

    const ordersIdToConfirmRecordConfirmationRecord = await cashlessOfflineRepository.getConfirmationRecordOfflineOrders();
    if (ordersIdToConfirmRecord.length > 0 || ordersIdToConfirmRecordConfirmationRecord.length > 0) {
      const result = await cashlessRepository.confirmPendingRecord(
        [...ordersIdToConfirmRecord, ...ordersIdToConfirmRecordConfirmationRecord]
      );
      if (result) {
        cashlessOfflineRepository.removeRecordedConfirmationOrderFromStorageQueueAsync(
          result.ordersId.map((it) => ({ pedidoPOSId: it }))
        );
        cashlessOfflineRepository.removeConfirmationRecordOfflineOrders(
          result.ordersId
        );
      }
    }

    return responseSync;
  };

  const syncOrdersByIdAsync = async (
    localClienteId: string,
    orderId: string
  ) => {
    const storagePedidosPOS =
      await syncPendingOrdersRepository.getStoragePendentOrder();

    const storagePedidosPOSConfirmationRecord =
      await cashlessOfflineRepository.getNotSincronizedOfflineRecharges();

    let responseSync: responseSyncPedidoPos[] = [];

    if (storagePedidosPOS && storagePedidosPOS?.length > 0) {
      // Caso pagamento seja pix, será sincronizado como debito
      const pedidoPos = storagePedidosPOS.filter(
        (item) => item.pedidoPOSId === orderId
      );
      const pedidoPosParaSincronizar = pedidoPos.map((it) => ({
        ...it,
        tipoPagamento:
          it.tipoPagamento === TransactionType.pix
            ? TransactionType.debit
            : it.tipoPagamento,
      }));

      const dadosPedidoPOS: DadosPedidosPOS = {
        localClienteId: localClienteId,
        tipoDispositivo: 2,
        superAppEventId: pedidoPosParaSincronizar[0]?.superAppEventId,
        sincronizarPedidoPOSInsertModel: JSON.stringify(
          pedidoPosParaSincronizar ?? "[]"
        ),
      };
      addLog && addLog("Request syncOrdersByIdAsync", pedidoPosToLog(pedidoPosParaSincronizar));
      const result = await SincronizarPedidoPOSAsync(dadosPedidoPOS);
      if (result) {
        responseSync = [...responseSync, ...result];
        await syncPendingOrdersRepository.removeSendedOrderFromStorageQueueAsync(
          result
        );
      }
    }

    if (
      storagePedidosPOSConfirmationRecord &&
      storagePedidosPOSConfirmationRecord?.length > 0
    ) {
      // Caso pagamento seja pix, será sincronizado como debito
      const pedidoPos = storagePedidosPOSConfirmationRecord.filter(
        (item) => item.pedidoPOSId === orderId
      );
      const pedidoPosParaSincronizar = pedidoPos.map((it) => ({
        ...it,
        tipoPagamento:
          it.tipoPagamento === TransactionType.pix
            ? TransactionType.debit
            : it.tipoPagamento,
      }));

      const dadosPedidoPOS: DadosPedidosPOS = {
        localClienteId: localClienteId,
        tipoDispositivo: 2,
        superAppEventId: pedidoPosParaSincronizar[0]?.superAppEventId,
        sincronizarPedidoPOSInsertModel: JSON.stringify(
          pedidoPosParaSincronizar ?? "[]"
        ),
      };
      addLog && addLog("Request", pedidoPosToLog(pedidoPosParaSincronizar));
      const result = await SincronizarPedidoPOSAsync(dadosPedidoPOS);
      if (result) {
        responseSync = [...responseSync, ...result];
        syncPendingOrdersRepository.removeSendedOrderFromStorageQueueAsync(
          result
        );
      }
    }
    return responseSync;
  };

  const sendFreeOrdersAsync = async (
    order: Order,
    localClientId: string,
    tipoPagamento?: TransactionType,
    transacaoAdquirente?: FinancialTransactionModel
  ): Promise<PedidoPos> => {
    const pedidoPos: PedidoPos = orderToPedidoPOS(
      order,
      tipoPagamento,
      transacaoAdquirente
    );

    const pedidoPosParaSincronizar = {
      ...pedidoPos,
      tipoPagamento:
        tipoPagamento === TransactionType.pix
          ? TransactionType.debit
          : tipoPagamento,
    };

    const dadosPedidoPOS: DadosPedidosPOS = {
      localClienteId: localClientId,
      tipoDispositivo: 2,
      sincronizarPedidoPOSInsertModel: JSON.stringify([
        pedidoPosParaSincronizar,
      ]),
    };

    const responseSync = await SincronizarPedidoPOSAsync(dadosPedidoPOS);

    if (responseSync.find((res) => res.pedidoPOSId === order.id)) {
      return pedidoPos;
    } else {
      throw GetError(
        "Pedido Não enviado",
        "onSucessPayment",
        "SyncOrderUseCase",
        "Falha ao sincronizar pedido",
        ErrorCodeType.ORDER
      );
    }
  };


  const syncPreCashlessOffline = async (order: PedidoPos, localClienteId: string, equipamentId: string, transactionType: TransactionType) => {

    try {
      let request: IRechargeAccountRequest = {
        localId: localClienteId,
        accountId: order.clienteEstabelecimentoObject?.pedidoPosPaiId ?? "",
        //operatorId: "dda49bf0-c5d3-4511-928d-0e35b746222d",
        equipamentId: equipamentId,
        orderId: order.pedidoPOSId ?? "",
        payments: [
          {
            amount: order.valorTotal,
            discount: 0,
            installments: 1,
            paymentType: transactionType,
            transactionResponse: JSON.stringify(order?.dadosTransacaoObject),
            success: true,
            hasDiscountInAmount: false,
          },
        ],
        //meepUserId: "",
        rechargeMotive: "Recarga Totem",
        rechargeValue: order.valorTotal,
        isOfflineRecharge: order.isOfflineRecharge,
        tag: order.clienteEstabelecimentoObject?.tag ?? "",
        userAccount: {
          document: order.clienteEstabelecimentoObject?.cpf ?? "",
          documentType: 0,
        },
        recharges: [
          {
            orderID: order.pedidoPOSId ?? "",
            //operatorId: "dda49bf0-c5d3-4511-928d-0e35b746222d",//TODO:OPERATOR FORCED ID
            amount: order.valorTotal,
            discount: 0,
            hasDiscountInAmount: false,
            discountOperatorName: "",
            installments: 1,
            paymentType: transactionType,
            success: true,
            transactionResponse: JSON.stringify(order?.dadosTransacaoObject),
          }],
        isDataRecorded: order.isOfflineRechargeRecordConfirmed,
        createdAt: new Date().toISOString(),
      };


      if (order.isClosed) {
        request.activationValue = order.activationValue ?? 0;
        const response = await cashlessRepository.rechargeOfflineAccountOpenAccount(request);
        return response;
      } else {
        const response = await cashlessRepository.rechargeOfflineAccount(request);
        return response;
      }
    } catch (error) {
      GetError(
        error,
        "SyncOrderUseCase",
        "SyncOrderUseCase",
        "Falha ao sincronizar pedido",
        ErrorCodeType.GENERAL
      );
    }
  }




  return {
    sendOrderAsync,
    sendOrderOfflineRechargeAsync,
    syncOrdersAsync,
    syncOrdersByIdAsync,
    getPasswordPainel,
    sendFreeOrdersAsync,
  };
};
